var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplace = function SvgReplace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.714 7.241h4.138M8.714 9.31h4.138m-4.138 2.069h2.069m-.86 6.5 1.527 1.534m0 0-1.457 1.466m1.457-1.466H7.7M17 7.48h1.265a1 1 0 0 1 1 1v9.037a1 1 0 0 1-1 1h-4.207m.207-3H7.3a1 1 0 0 1-1-1V5.483a1 1 0 0 1 1-1h6.965a1 1 0 0 1 1 1v9.034a1 1 0 0 1-1 1Z"
  })));
};
export default SvgReplace;